exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  \tmargin: 0;\n  \tpadding: 0;\n  \tfont-family: 'Josefin Sans', sans-serif;\n  \tfont-size: 160%;\n}\nh1 {\n\tposition: relative;\n\tfont-family: 'Arizonia', cursive;\n\tfont-size: 300%;\n\n}\nh1 span{\n\tposition: absolute; \n\ttop: -200px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss"}!./src/index.css
// module chunks = 0